/*
 * Author: Harper Yan
 * File Created: Sunday, 24-07-21 09:43 am
 * Last Modified: Monday, 25-07-21 10:58 am, by Dw
 */
import { MouseEventHandler } from 'react';
import { Dialog as MuiDialog, DialogProps as MuiDialogProps, DialogTitle, DialogTitleProps, IconButton } from '@mui/material';
import { Icon } from '../../../Icon';
import { useScreenSize } from '../../../utils';
export interface BaseDialogProps extends MuiDialogProps {
  showClose?: boolean;
  disableBackdropClose?: boolean;
  titleProps?: DialogTitleProps;
  autoAdjust?: boolean;
}
export const BaseDialog = ({
  showClose = true,
  onClose,
  children,
  title,
  titleProps,
  autoAdjust,
  ...rest
}: BaseDialogProps) => {
  const handleClose: MouseEventHandler<HTMLButtonElement> = e => onClose!(e, 'escapeKeyDown');
  const isXs = useScreenSize('xs');
  const fullScreen = autoAdjust ? isXs : rest.fullScreen;
  return <MuiDialog sx={{
    borderRadius: '12px'
  }} {...rest} fullScreen={fullScreen} onClose={onClose} data-sentry-element="MuiDialog" data-sentry-component="BaseDialog" data-sentry-source-file="BaseDialog.tsx">
      {showClose && <IconButton aria-label="close" className="dialog-close" onClick={handleClose} sx={{
      position: 'absolute',
      right: '16px',
      top: '16px',
      color: '#707A8A',
      p: '0',
      zIndex: 1300,
      [`&:hover`]: {
        color: 'primary.main',
        background: 'inherit'
      }
    }}>
          <Icon name="Close" sx={{
        fontSize: '16px'
      }} />
        </IconButton>}
      {title && <DialogTitle {...titleProps} sx={{
      textAlign: 'left',
      ...titleProps?.sx
    }}>
          {title}
        </DialogTitle>}
      {children}
    </MuiDialog>;
};